<template>
        <div class="hero-bg" :style="`background-image: url('${routes.cdn_url}/images/redesign/home/hero/equations.png')`"></div>
</template>

<script>
    export default {
    }
</script>

<style lang="scss" scoped>
    .hero-bg {
        background-repeat:no-repeat;
        background-size: cover;
        background-position:center;
        position: absolute;
        top: 75px;
        height: 50vh;
        width: 100%;
        z-index: -1;
    }

    @media (max-width: 1200px) {
        // rules here apply to devices from 993px to 1200px (inclusive)
        .hero-bg {
            max-height: 80vh;
        }
    }
    @media (max-width: 992px) {	
        // rules here apply to devices from 769px to 992px (inclusive)
    }
    @media (max-width: 768px) {
        // rules here apply to devices from 0px to 768px (inclusive)
    }
</style>
